import React, { useState, useEffect } from 'react';

interface Props {
    initialTime: number;
    whenDone?: () => void;
}

const TimerCountDown: React.FC<Props> = ({ initialTime, whenDone }) => {
    const [timeLeft, setTimeLeft] = useState(initialTime);

    const countDown = () => {
        setTimeLeft((prevTime) => prevTime - 1);
    };
    let intervalId: NodeJS.Timer;
    useEffect(() => {
        intervalId = setInterval(countDown, 1000);
        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        if (timeLeft === 0) {
            clearInterval(intervalId);
            whenDone && whenDone();
        }
    }, [timeLeft, whenDone]);

    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;

    return (
        <div className='ml-[5px]'>
            {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
        </div>
    );
};

export default TimerCountDown;
